import React from 'react';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import {
    TableRow,
    TableCell,
    TableSortLabel,
    Typography,
    TableFooter,
    Button,
    IconButton
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    labelHeader: {
        textTransform: 'uppercase'
    },
    cell: {
        lineHeight: '35px'
    },
    sortable: {
        cursor: 'not-allowed',
        '& *': {
            cursor: 'not-allowed'
        }
    },
    sortActive: {
        '& *': {
            color: theme.palette.primary.main,
            fontWeight: 500
        }
    }
}));

const EnhancedTableFooter = props => {
    const { order, orderBy, onRequestSort, headers } = props;
    const classes = useStyles();

    return (
        <TableFooter>
            <TableRow>
                {headers.map((row, index) =>
                    row.onClick ? (
                        <TableCell
                            className={clsx(classes.cell)}
                            size="small"
                            key={index}
                            align={row.align}
                            style={row.style ?? {}}
                            padding={row.padding ?? 'normal'}>
                            {typeof row.label === 'string' ? (
                                <Button size="small" onClick={row.onClick} disabled={row.disabled}>
                                    <Typography variant="body2" className={classes.labelHeader}>
                                        {row.label}
                                    </Typography>
                                </Button>
                            ) : (
                                <IconButton onClick={row.onClick} disabled={row.disabled}>
                                    {row.label}
                                </IconButton>
                            )}
                        </TableCell>
                    ) : (
                        <TableCell
                            className={clsx(classes.cell, {
                                [classes.sortActive]: orderBy === row.id,
                                [classes.sortable]: !row.sortable
                            })}
                            size="small"
                            key={index}
                            align={row.align}
                            sortDirection={orderBy === row.id ? order : false}
                            style={row.style ?? {}}
                            padding={row.padding ?? 'normal'}>
                            <TableSortLabel
                                disabled={!row.sortable}
                                active={orderBy === row.id}
                                direction={orderBy === row.id ? order : 'asc'}
                                onClick={event => onRequestSort(event, row.id)}>
                                <Button size="small">
                                    <Typography variant="body2" className={classes.labelHeader}>
                                        {row.label}
                                    </Typography>
                                </Button>
                            </TableSortLabel>
                        </TableCell>
                    )
                )}
            </TableRow>
        </TableFooter>
    );
};

export default EnhancedTableFooter;
